<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      apiKey: '',
      apiSecret: '',
      accessToken: '',
      accessSecret: '',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    apiKey: { required },
    apiSecret: { required },
    accessToken: { required },
    accessSecret: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const twitterChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            channel: {
              type: 'twitter',
              provider_config: {
                api_key: this.apiKey,
                api_secret: this.apiSecret,
                access_token: this.accessToken,
                access_secret: this.accessSecret,
              },
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: twitterChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.TWITTER.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.TWITTER.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.TWITTER.DESC')"
    />
    <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.apiKey.$error }">
          <span>
            {{ $t('INBOX_MGMT.ADD.TWITTER.API_KEY.LABEL') }}
          </span>
          <input
            v-model="apiKey"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.TWITTER.API_KEY.PLACEHOLDER')"
            @blur="v$.apiKey.$touch"
          />
          <span v-if="v$.apiKey.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.TWITTER.API_KEY.ERROR') }}
          </span>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.apiSecret.$error }">
          <span>
            {{ $t('INBOX_MGMT.ADD.TWITTER.API_SECRET.LABEL') }}
          </span>
          <input
            v-model="apiSecret"
            type="password"
            :placeholder="$t('INBOX_MGMT.ADD.TWITTER.API_SECRET.PLACEHOLDER')"
            @blur="v$.apiSecret.$touch"
          />
          <span v-if="v$.apiSecret.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.TWITTER.API_SECRET.ERROR') }}
          </span>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.accessToken.$error }">
          <span>
            {{ $t('INBOX_MGMT.ADD.TWITTER.ACCESS_TOKEN.LABEL') }}
          </span>
          <input
            v-model="accessToken"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.TWITTER.ACCESS_TOKEN.PLACEHOLDER')"
            @blur="v$.accessToken.$touch"
          />
          <span v-if="v$.accessToken.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.TWITTER.ACCESS_TOKEN.ERROR') }}
          </span>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.accessSecret.$error }">
          <span>
            {{ $t('INBOX_MGMT.ADD.TWITTER.ACCESS_SECRET.LABEL') }}
          </span>
          <input
            v-model="accessSecret"
            type="password"
            :placeholder="$t('INBOX_MGMT.ADD.TWITTER.ACCESS_SECRET.PLACEHOLDER')"
            @blur="v$.accessSecret.$touch"
          />
          <span v-if="v$.accessSecret.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.TWITTER.ACCESS_SECRET.ERROR') }}
          </span>
        </label>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.TWITTER.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
